import React,{ useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation,useNavigate } from "react-router-dom";
import { updatePayment } from "../../features/userSlice";
import { msgAccessPromt } from "../../constant/constant";
const PaymentStatus = React.memo(({getpay}) => {
  const location = useLocation();
  const transactionId = new URLSearchParams(location.search).get("trans_id");
  const navigate = useNavigate();
  const dispatch=useDispatch();

  const fetchPayment=useCallback(async(txnId)=>{
      let dataSet = new FormData();  
      
      
      dataSet.append('TRANS_ID',txnId);
      const data = await dispatch(updatePayment(dataSet)).unwrap();
      if(data.status===true){
        msgAccessPromt({dispatch,error:false,msg:data.message});
      }else if(data.message==='Your Payment is pending please wait'){
        msgAccessPromt({dispatch,error:false,msg:data.message});
      }else{
        msgAccessPromt({dispatch,error:true,msg:data.message});
      }
              
      navigate("/");
  },[dispatch,navigate]);
  
  
  
  useEffect(()=>{
  if (transactionId) {
    fetchPayment(transactionId);
  }
  },[fetchPayment,transactionId]);


  return <div>
 

  </div>;
});

export default PaymentStatus;
